import momentTz from 'moment-timezone';
import { ScheduleFormState } from 'modules/campaigns/editor/types';
import { selectUserProjectTimeZone } from 'core/userContext';
import { useSelector } from 'react-redux';
import { BoldText } from 'modules/campaigns/editor/styles';
import { useCampaignSendSize } from 'modules/campaigns/lib/hooks';
import { getSendSizeContent } from 'modules/campaigns/editor/utils';
import { useCampaignContext } from 'modules/campaigns/editor/context';

import {
  getScheduleCampaignTargetTimeZone,
  getStartTimeInEpochMs,
} from '../../ScheduleCampaignModal/ScheduleCampaignModal.utils';

const getTzText = (tz: string) => `${tz} (${momentTz.tz(tz).zoneAbbr()})`;

export const RecipientTimeZoneScheduleDateSummary = ({ values }: { values: ScheduleFormState }) => {
  const { estimatedSendSizeData, expectedSendSizeData } = useCampaignContext();
  const { sendSize, isEstimated } = useCampaignSendSize({
    estimatedSendSizeData,
    expectedSendSizeData,
  });
  const projectTimeZone = useSelector(selectUserProjectTimeZone);

  const { startDate, startTime, scheduleType, startingTimeZone, fallbackTimeZone } = values;

  const targetTimeZone = getScheduleCampaignTargetTimeZone(
    projectTimeZone,
    startingTimeZone,
    scheduleType,
  );

  const scheduleDateTime = getStartTimeInEpochMs(startDate, startTime, targetTimeZone);
  const scheduleDate = momentTz(scheduleDateTime).tz(targetTimeZone);

  return (
    <>
      This campaign will send to <BoldText>{getSendSizeContent(sendSize, isEstimated)}</BoldText>{' '}
      starting on <BoldText>{scheduleDate.format('dddd, MMMM Do YYYY [at] h:mm A')}</BoldText> in
      the recipients&apos; time zone.
      <br />
      <br />
      Starting time zone: <BoldText>{getTzText(startingTimeZone as string)}</BoldText>
      <br />
      Fallback time zone: <BoldText>{getTzText(fallbackTimeZone as string)}</BoldText>
    </>
  );
};
